import React, { useEffect, useRef, useState } from 'react';
import { Options } from '.';

interface OwnProps {
  placeholder: string;
  options: Options[];
  selectedLocations: string[];
  onChange: (value: string[], isMobile: boolean) => void;
}

// Icon component
const Icon = ({ isOpen }: { isOpen: boolean }) => {
  return (
    <svg
      className={`accordion__item-icon-arrow-up ${isOpen ? 'translate' : ''}`}
      role="presentation"
    >
      <use xlinkHref="#arrow-up"></use>
    </svg>
  );
};

// ListingSelect component
const ListingSelect = ({ placeholder, options, selectedLocations, onChange }: OwnProps) => {
  const [showMenu, setShowMenu] = useState(false);
  const inputRef = useRef<HTMLDivElement>(null);
  const dropdownMenuRef = useRef<HTMLDivElement>(null); // Ref for the dropdown menu
  const [selected, setSelected] = useState<string[]>(
    selectedLocations.includes('all') ? [] : selectedLocations
  );

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(e.target as Node) &&
        dropdownMenuRef.current &&
        !dropdownMenuRef.current.contains(e.target as Node)
      ) {
        setShowMenu(false);
      }
    };

    window.addEventListener('click', handler);
    return () => window.removeEventListener('click', handler);
  }, []);

  const handleInputClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (inputRef.current && inputRef.current.contains(e.target as Node)) {
      setShowMenu(!showMenu);
    }
  };

  const getDisplay = () => {
    if (selected.length === 0) {
      return placeholder;
    }

    if (selected.includes('all')) {
      return `Categories selected (${selected.length - 1})`;
    }

    return `Categories selected (${selected.length})`;
  };

  const handleCheckboxChange = (optionId: string) => {
    // if (selected.includes('all')) {
    //   // we remove the all from the selected array, and just add the selected option plus the rest of the selected options

    //   setSelected([optionId, ...selected.filter(id => id !== 'all')]);
    // }

    setSelected(prevSelected => {
      if (prevSelected.includes(optionId)) {
        return prevSelected.filter(id => id !== optionId);
      }

      return [...prevSelected, optionId];
    });
  };

  return (
    <>
      <div
        ref={inputRef}
        onClick={e => handleInputClick(e)}
        className={`listings-select__dropdown-input ${showMenu ? 'open' : ''}`}
      >
        <div
          className={`dropdown-selected-value ${!selectedLocations || selectedLocations.length === 0 ? 'placeholder' : ''}`}
        >
          {getDisplay()}
        </div>
        <div className="dropdown-tools">
          <div className="dropdown-tool">
            <Icon isOpen={showMenu} />
          </div>
        </div>
      </div>

      {showMenu && (
        <div ref={dropdownMenuRef} className="listings-select__dropdown-menu">
          {options.map(option => {
            if (option.id === 'all') {
              return null;
            }

            return (
              <label key={option.id} className="listings-select__check-container" id={option.id}>
                {option.value}
                <input
                  type="checkbox"
                  value={option.value}
                  id={option.id}
                  defaultChecked={selected.includes(option.id)}
                  onClick={() => handleCheckboxChange(option.id)}
                />
                <span className="check-mark"></span>
              </label>
            );
          })}

          <button
            className="btn btn--secondary"
            onClick={() => {
              onChange(
                selected.length === 0 || selected.length + 1 === options.length
                  ? ['all']
                  : selected,
                true
              );
              setShowMenu(false);
            }}
          >
            <span>Apply</span>
          </button>
        </div>
      )}
    </>
  );
};

export default ListingSelect;
